import './footer.scss'

const Footer = () => {
  return (
    <footer className='footer'>
      <p>&copy; {new Date().getFullYear()} EzGuitarScales. All rights reserved.</p>
    </footer>
  )
}

export default Footer
